import { render, staticRenderFns } from "./BsDateTimeField.vue?vue&type=template&id=76c76da4&scoped=true&"
import script from "./BsDateTimeField.vue?vue&type=script&lang=js&"
export * from "./BsDateTimeField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c76da4",
  null
  
)

export default component.exports